export default __webpack_public_path__ + "static/media/message_send.e4ac5474.mp3";